import { render, staticRenderFns } from "./BusinessTab.vue?vue&type=template&id=f7558ef6"
import script from "./BusinessTab.vue?vue&type=script&lang=js"
export * from "./BusinessTab.vue?vue&type=script&lang=js"
import style0 from "./BusinessTab.vue?vue&type=style&index=0&id=f7558ef6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports